import { useRef, useEffect, useState } from 'react';
import { useInView } from 'framer-motion';

/**
 * Counts up to `target` (number) when it enters the viewport.
 * For non-numeric values (e.g. "Tous niveaux"), displays as-is.
 */
const AnimatedCounter = ({ target, suffix = '', prefix = '', duration = 1800 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [display, setDisplay] = useState(typeof target === 'number' ? 0 : target);

  useEffect(() => {
    if (!isInView || typeof target !== 'number') return;

    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      // ease out quad
      const eased = 1 - (1 - progress) * (1 - progress);
      setDisplay(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
      else setDisplay(target);
    };
    requestAnimationFrame(step);
  }, [isInView, target, duration]);

  return (
    <span ref={ref}>
      {prefix}{display}{suffix}
    </span>
  );
};

export default AnimatedCounter;
